import moment from 'moment';
import { Moment, Duration } from 'moment';
import { NumberHelper } from './number-helper';

export class TimePart {

    public static fromNumeric(hours: number, minutes: number): TimePart {
        return new TimePart({ hours, minutes });
    }

    public static fromString(hhmm: string): TimePart {
        return new TimePart(hhmm);
    }

    public static fromDuration(durationInstance: Duration): TimePart {
        return new TimePart(durationInstance);
    }

    private _isATimePartObject: boolean;
    private _duration: Duration;

    constructor(arg?: any) {
        this._isATimePartObject = true;
        if (this._isATimePartObject) {
            // nop
        }

        if (arg) {
            if (arg._isATimePartObject) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                this._duration = arg._duration.clone();
            } else if (moment.isDuration(arg)) {
                this._duration = arg.clone();
            } else if (arg instanceof Date) {
                this._duration = moment.duration({ hours: arg.getHours(), minutes: arg.getMinutes(), second: arg.getSeconds() });   // Otherwhise may be changed to utc time
            } else {
                this._duration = moment.duration(arg);
            }
        } else {
            this._duration = moment.duration();
        }
    }

    public toString(): string {
        return `${NumberHelper.format(this._duration.hours(), 2)}:${NumberHelper.format(this._duration.minutes(), 2)}`;

    }
    public toISOString(): string {
        return this._duration.toISOString();
    }

    public toMoment(): Moment {
        return moment({ hours: this._duration.hours(), minutes: this._duration.minutes() });
    }

    public add(amount: number, part: moment.unitOfTime.DurationConstructor): TimePart {
        return TimePart.fromDuration(this._duration.clone().add(amount, part));
    }

    public subtract(amount: number, part: moment.unitOfTime.DurationConstructor): TimePart {
        return TimePart.fromDuration(this._duration.clone().subtract(amount, part));
    }

    public hours(): number {
        return this._duration.hours();
    }

    public minutes(): number {
        return this._duration.minutes();
    }

    public seconds(): number {
        return this._duration.seconds();
    }

    public asMinutes(): number {
        return this._duration.asMinutes();
    }

}
